$(document).ready(function(){
    $('#goddress_list').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 5000,
        slidesToShow: 8,
        slidesToScroll: 1,
        rtl: true,
        responsive: [
        {
            breakpoint: 1024, 
            settings: {
            slidesToShow: 8,
            }
        },
        {
            breakpoint: 623,
            settings: {
            slidesToShow: 4,
            }
        },{
            breakpoint: 480,
            settings: {
            slidesToShow: 2,
            }
        }
        ]
    });
    $(function () {
        function sliderSetting() {
    
        var width = $(window).width();
    
        if (width <= 623) {
            $('.slider').not('.slick-initialized').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false
            });
        } else {
            $('.slider.slick-initialized').slick('unslick');
        }
        }
    
        sliderSetting();
    
        $(window).resize(function () {
        sliderSetting();
        });
    });
});